// #region imports

// --- Angular
import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  OnDestroy,
  OnChanges,
  SimpleChanges,
  Output,
} from '@angular/core';

// --- RxJs
import { BehaviorSubject, Subject, Subscription } from 'rxjs';

// --- HS Code
import {
  Constants,
  GroupModel,
  InvitationTypes,
  RespondentModel,
  RespondentStatuses,
  SurveySummaryModel,
} from '../../../models';

// #endregion

@Component({
  selector: 'hs-respondents-widget-group-item',
  templateUrl: './respondents-widget-group-item.component.html',
  styleUrls: ['./respondents-widget-group-item.component.scss'],
})
export class RespondentsWidgetGroupItemComponent implements OnInit, OnChanges {
  public show: boolean = false;

  @Input() respondentGroup: GroupModel | undefined;
  @Input() selectedSurvey: SurveySummaryModel | null = null;
  @Input() respondentGroupInfoList: SurveySummaryModel[] = new Array<SurveySummaryModel>();
  @Input() name: string = '';
  @Input() groupIndex: number = 0;
  @Input() isExpanded: boolean = false;

  @Output() sendReminder = new EventEmitter<RespondentModel>();
  @Output() panelCollapsed = new EventEmitter<number>();

  respondents: RespondentModel[] = [];
  respondentStatuses = RespondentStatuses;
  invitationTypes = InvitationTypes;
  gIndex = 0;

  constructor() {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['respondentGroup'] && changes['respondentGroup'].currentValue) {
      if (!this.respondentGroup) return;

      this.respondents = this.respondentGroup.respondents.filter(r => r.isSet || r.groupIndex <= Constants.NUMBER_OF_RESPONDENTS_PER_GROUP);
    }
  }

  onSendReminder(respondent: RespondentModel) {
    this.sendReminder.emit(respondent);
  }

  onCollapseExpand() {
    this.panelCollapsed.emit(this.groupIndex);
  }
}
